import { VistaprintAuth } from '@vp/auth-react';

const webAuth = new VistaprintAuth.WebAuth();

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const getAuthHeader = () => ({
  headers: {
    Authorization: `Bearer ${webAuth.getToken()}`,
    'Content-Type': 'application/json',
  },
});
